import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/mute-green.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-green.mp4";
import manuelVideo from "../../assets/avatares/juan-cocina.webm"; 
import manuelVideoMp4 from "../../assets/avatares/juan-cocina.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import excelenteAvatar from "../../assets/bg/excelente-avatar.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario5Conclusion({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	
	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});
		
	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Ahora mismo estoy bien. He vuelto al trabajo, hago vida normal y el tratamiento me está funcionando.<br/>Sigo con controles, con seguimiento… pero puedo decir que tengo calidad de vida, y eso es lo más importante para mí."

	const handleContinue = () => {
		navigate(ROUTES.FINAL_SCENE);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "green", true);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);
	
	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 100);
		return () => clearTimeout(timer);
	}, []);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0 bgCircleBlue">
            <div className="row h-100 m-0">
            <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                <div className="content-overlay d-flex flex-column justify-content-start align-items-center h-75 px-5 position-relative pt-5">
                <img
                    src={oncommit}
                    alt="decorativo"
                    style={{ maxWidth: "187px", top: "18px", left: "20px" }}
                    className="position-absolute"
                />
                <img
                    src={excelenteAvatar}
                    alt="decorativo"
                    className="mb-5 mt-5"
                    style={{ maxWidth: "700px" }}
                />
                <div className="black txt26 w-50 text-center">
                    <p>
                    Excelente, han completado la última sala
                    </p>
                </div>
				<div className="d-flex justify-content-center">
					<div
						className={`button-escuchar-paciente button-escuchar-paciente-green mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
						aria-disabled={!canOpenDialog}
						onClick={canOpenDialog ? abrirModal : undefined}
						style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
					>
						Escuchar al paciente
					</div>
				</div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
	);
}

export default injectIntl(Scenario5Conclusion);